import { render, staticRenderFns } from "./SliderButton.vue?vue&type=template&id=3dcc0c66&"
import script from "./SliderButton.vue?vue&type=script&lang=js&"
export * from "./SliderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports